<script setup lang="ts">
import ApplicationLogo from '@/Components/ApplicationLogo.vue';
import { Link } from '@inertiajs/vue3';
</script>

<template>
    <div class="min-vh-100 d-flex flex-column align-items-center bg-light pt-4 justify-content-center">
        <div class="mb-3">
            <Link href="/">
                <ApplicationLogo style="width: 80px; height: 80px;" />
            </Link>
        </div>

        <div class="w-100" style="max-width: 480px;">
            <div class="card shadow-sm">
                <div class="card-body">
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>
